import Box from '@sendsprint/ui-react/dist/components/Box';
import Text from '@sendsprint/ui-react/dist/components/Text';
import BsInfoCircleFill from '@src/assets/svgs/transformed/react-icons/bs/BsInfoCircleFill';
import BsCheckCircleFill from '@src/assets/svgs/transformed/react-icons/bs/BsCheckCircleFill';
import { ReactNode } from 'react';
import FaTimesCircle from '@src/assets/svgs/transformed/react-icons/fa/FaTimesCircle';

type StatusType = 'Processed' | 'Pending' | 'Failed';

interface StatusInfoProps {
  variant: StatusType;
  value: ReactNode;
}

const StatusInfo = ({ variant, value }: StatusInfoProps) => {
  return (
    <Box className="ss-flex ss-gap-1 ss-items-center">
      {variant === 'Processed' && (
        <Box className="ss-w-5 ss-h-5 ss-rounded-full ss-bg-success-50 ss-flex ss-items-center ss-justify-center">
          <BsCheckCircleFill width={14} height={14} className="ss-text-success-500" />
        </Box>
      )}
      {variant === 'Pending' && (
        <Box className="ss-w-5 ss-h-5 ss-rounded-full ss-bg-warning-50 ss-flex ss-items-center ss-justify-center">
          <BsInfoCircleFill width={14} height={14} className="ss-text-warning-500" />
        </Box>
      )}
      {variant === 'Failed' && (
        <Box className="ss-w-5 ss-h-5 ss-rounded-full ss-bg-error-50 ss-flex ss-items-center ss-justify-center">
          <FaTimesCircle width={14} height={14} className="ss-fill-error-500" />
        </Box>
      )}
      <Text className="ss-text-neutral-400 ss-font-semibold" variant="paragraphSmall">
        {variant}: {value}
      </Text>
    </Box>
  );
};

export default StatusInfo;
